import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '../../../base/ui/components/web/Button';
import AbstractPollsPane from '../AbstractPollsPane';
import PollCreate from './PollCreate';
import PollsList from './PollsList';
import { useSelector } from 'react-redux';
import { isLocalParticipantCanPoll } from '../../../poll-moderation/functions';
/* eslint-enable lines-around-comment */
const useStyles = makeStyles()(() => {
    return {
        container: {
            height: '100%',
            position: 'relative'
        },
        listContainer: {
            height: 'calc(100% - 12px)',
            overflowY: 'auto'
        },
        listContainerCanCreate: {
            height: 'calc(100% - 88px)',
            overflowY: 'auto'
        },
        footer: {
            position: 'absolute',
            bottom: 0,
            padding: '24px',
            width: '100%',
            boxSizing: 'border-box'
        }
    };
});
const PollsPane = ({ createMode, onCreate, setCreateMode, t }) => {
    const { classes } = useStyles();
    const canCreatePolls = useSelector(isLocalParticipantCanPoll);
    const editPoll = useSelector((state) => state['features/polls']).pollId;
    return (createMode || editPoll)
        ? React.createElement(PollCreate, { setCreateMode: setCreateMode })
        : React.createElement("div", { className: classes.container },
            React.createElement("div", { className: canCreatePolls ? classes.listContainerCanCreate : classes.listContainer },
                React.createElement(PollsList, { setCreateMode: setCreateMode })),
            canCreatePolls && (React.createElement("div", { className: classes.footer },
                React.createElement(Button, { size: "bMedium", fullWidth: true, labelKey: 'polls.create.create', onClick: onCreate }))));
};
/*
 * We apply AbstractPollsPane to fill in the AbstractProps common
 * to both the web and native implementations.
 */
// eslint-disable-next-line new-cap
export default AbstractPollsPane(PollsPane);
